// E.164 test number used when user has no numbers (shared; concurrent limit applies)
export const TEST_PHONE_NUMBER = process.env.REACT_APP_TEST_PHONE_NUMBER || '+18055000806';

export function formatPhoneDisplay(e164) {
  if (!e164 || typeof e164 !== 'string') return e164 || '';
  const digits = e164.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return e164;
}
